'use client'

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  return (
    <html lang="en">
      <body style={{ margin: 0, backgroundColor: '#1d212a', color: 'white', fontFamily: 'system-ui, sans-serif' }}>
        <div style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '2rem',
        }}>
          <div style={{ textAlign: 'center', maxWidth: '500px' }}>
            <div style={{ fontSize: '80px', marginBottom: '16px', lineHeight: 1 }}>⚡</div>
            <h1 style={{ fontSize: '36px', fontWeight: 400, marginBottom: '12px', lineHeight: 1.2 }}>
              Something went very wrong.
            </h1>
            <p style={{ color: '#8a8f9e', fontSize: '18px', marginBottom: '32px', lineHeight: 1.5 }}>
              A critical error occurred. We&apos;ve been notified.
            </p>
            <div style={{ display: 'flex', gap: '16px', justifyContent: 'center', flexWrap: 'wrap' }}>
              <button
                onClick={reset}
                style={{
                  backgroundColor: '#544ae8',
                  color: 'white',
                  border: '1px solid #475065',
                  borderRadius: '100px',
                  padding: '16px 32px',
                  fontSize: '18px',
                  cursor: 'pointer',
                }}
              >
                Try Again
              </button>
              <a
                href="/"
                style={{
                  border: '1px solid rgba(255,255,255,0.2)',
                  color: 'white',
                  borderRadius: '100px',
                  padding: '16px 32px',
                  fontSize: '18px',
                  textDecoration: 'none',
                  display: 'inline-block',
                }}
              >
                Go Home
              </a>
            </div>
            {error.digest && (
              <p style={{ color: '#3e4658', fontSize: '12px', marginTop: '40px', fontFamily: 'monospace' }}>
                Error ID: {error.digest}
              </p>
            )}
          </div>
        </div>
      </body>
    </html>
  )
}
